const normalizeLineEndings = (text) =>
  text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");

const parseCsvLine = (line) => {
  const values = [];
  let current = "";
  let inQuotes = false;

  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    const next = line[i + 1];

    if (char === '"') {
      if (inQuotes && next === '"') {
        current += '"';
        i++;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }

    if (char === "," && !inQuotes) {
      values.push(current);
      current = "";
      continue;
    }

    current += char;
  }

  values.push(current);
  return values;
};

export const parseCsvText = (
  text,
  { header = true, skipEmptyLines = true } = {},
) => {
  const normalized = normalizeLineEndings(text || "");
  const lines = normalized.split("\n");

  const filteredLines = skipEmptyLines
    ? lines.filter((line) => line.trim() !== "")
    : lines;

  if (filteredLines.length === 0) {
    return {
      data: [],
      meta: { fields: [] },
    };
  }

  if (!header) {
    return {
      data: filteredLines.map(parseCsvLine),
      meta: { fields: [] },
    };
  }

  const headers = parseCsvLine(filteredLines[0]);
  const rows = filteredLines.slice(1).map((line) => {
    const values = parseCsvLine(line);
    const row = {};

    for (let i = 0; i < headers.length; i++) {
      const key = headers[i] ?? "";
      row[key] = values[i] ?? "";
    }

    return row;
  });

  return {
    data: rows,
    meta: { fields: headers },
  };
};

const escapeCsvValue = (value) => {
  if (value === null || value === undefined) return "";

  const stringValue = String(value);
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }

  return stringValue;
};

export const toCsvText = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) return "";

  const headers = Array.from(
    rows.reduce((set, row) => {
      Object.keys(row || {}).forEach((key) => set.add(key));
      return set;
    }, new Set()),
  );

  const headerLine = headers.map(escapeCsvValue).join(",");
  const bodyLines = rows.map((row) =>
    headers.map((header) => escapeCsvValue(row?.[header])).join(","),
  );

  return [headerLine, ...bodyLines].join("\n");
};
